// component
import PurchaseFileDownloadListCom from './purchase-file-download-list/purchase-file-download-list.vue';

export default [
  {
    path: 'list',
    name: 'purchaseFileDownloadList',
    component: PurchaseFileDownloadListCom,
    meta: {
      title: '采购文件下载',
      breadCrumbShowIndexArr: [0, 2]
    }
  }
];

